// extracted by mini-css-extract-plugin
module.exports = {"border":"KeyBenefitsSection_border__C9B7_"};